import script from "./chooseAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseAgent.vue?vue&type=script&setup=true&lang=js"

import "./chooseAgent.vue?vue&type=style&index=0&id=ddc40530&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddc40530"]])

export default __exports__